import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackItemAddedToShowcase.meta';

export type UseTrackItemAddedToShowcaseParams = {
  /** Includes files on surfaces that cannot split them out — see `file_count`. */
  asset_count: number;
  board_count: number;
  /**
   * Only sent where assets and files are distinguishable (the picker knows each item's entity). On
   * id-only surfaces files ride inside `assetIds`, so the split isn't knowable and this is omitted.
   */
  file_count?: number;
};

export const useTrackItemAddedToShowcase = () => {
  const { track } = useAnalyticsUtilities();

  const trackItemAddedToShowcase = useCallback(
    (params: UseTrackItemAddedToShowcaseParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackItemAddedToShowcase };
};
